import { useQuery } from "react-query";
import { GET_FAMILY_MENTAL_HEALTH_HISTORY, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { getFamilyMentalHealthHistory } from "api/customers";

const useGetFamilyMentalHealthHistory = (clientId: number | null) => {
  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_FAMILY_MENTAL_HEALTH_HISTORY, clientId],
    () => getFamilyMentalHealthHistory(clientId),
    {
      staleTime: STALE_TIME_5_MINUTES,
      enabled: Boolean(clientId),
      refetchOnWindowFocus: false,
    }
  );

  return {
    familyMentalHealthHistory: (data?.data || []) as any[],
    familyMentalHealthHistoryLoading: isLoading,
    refetchFamilyMentalHealthHistory: refetch,
    ...rest,
  };
};

export default useGetFamilyMentalHealthHistory;
